import { activateLoading, deactivateLoading } from './GlobalSlice';
import { MY_LOADS_PAGINATION } from '../../Constants/Constants';
import { myLoadsTabs } from '../../Pages/MyLoads/MyLoadsContainer.tabs';
import { TMyLoadsTabs } from '../../Pages/MyLoads/MyLoadsContainer.type';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchDocumentBase64Data, fetchDocumentListData, fetchLoadData, fetchMyLoads } from '../APIServices/MyLoadsService';

type TsortAndFilterMyLoads = {
  size: number;
  page: number;
  sortColumn: string;
  sortDirection: string;
};

interface IMyLoadsState {
  myLoadsSortAndFilter: TsortAndFilterMyLoads;
  loadDetails: any;
  myLoadsData: any;
  myLoadsSectionSelectedTab: TMyLoadsTabs[];
}

const InitialSortAndFilterMyLoads = {
  size: MY_LOADS_PAGINATION.PAGE_SIZE,
  page: 0,
  sortColumn: '',
  sortDirection: 'asc',
};

const initialMyLoadsState: IMyLoadsState = {
  myLoadsSortAndFilter: { ...InitialSortAndFilterMyLoads },
  loadDetails: [],
  myLoadsData: {},
  myLoadsSectionSelectedTab: [...myLoadsTabs],
};

const initialState: IMyLoadsState = { ...initialMyLoadsState };

export const MyLoadsSlice = createSlice({
  name: 'MyLoads',
  initialState,
  reducers: {
    updateMyLoadsSectionSelectedTab: (state, action: PayloadAction<TMyLoadsTabs[]>) => {
      state.myLoadsSectionSelectedTab = action?.payload;
    },
    handleResetSortAndFilterMyLoads: (state) => {
      state.myLoadsSortAndFilter = { ...InitialSortAndFilterMyLoads };
    },
    handleResetPaginationFilterMyLoads: (state) => {
      state.myLoadsSortAndFilter = { ...state?.myLoadsSortAndFilter, page: 0 };
    },
    updateSortAndFilterMyLoads: (state, action: PayloadAction<TsortAndFilterMyLoads>) => {
      state.myLoadsSortAndFilter = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMyLoadsData.fulfilled, (state, action) => {
      if (action?.payload) {
        state.myLoadsData = action?.payload;
      }
    });
    builder.addCase(getLoadData.fulfilled, (state, action) => {
      if (action?.payload) {
        state.loadDetails = action?.payload;
      }
    });
  },
});

export const {
  updateMyLoadsSectionSelectedTab,
  handleResetSortAndFilterMyLoads,
  handleResetPaginationFilterMyLoads,
  updateSortAndFilterMyLoads
} = MyLoadsSlice.actions;

export default MyLoadsSlice.reducer;

export const getMyLoadsData = createAsyncThunk(
  'MyLoads/getMyLoadsData',
  async (payLoad: any, { dispatch }) => {
    try {
      const { requestPayload, hideLoader = false } = payLoad;
      !hideLoader && dispatch(activateLoading());
      const response: any = await fetchMyLoads(requestPayload);
      !hideLoader && dispatch(deactivateLoading());
      return response;
    } catch (error) {
      dispatch(deactivateLoading());
      return null;
    } finally {
      payLoad?.callback && payLoad?.callback();
    }
  },
);

export const getLoadData = createAsyncThunk(
  'MyLoads/getLoadData',
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchLoadData(payLoad);
    dispatch(deactivateLoading());
    return response;
  },
);

export const getDocumentListData = createAsyncThunk(
  'MyLoads/getDocumentListData',
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchDocumentListData(payLoad);
    dispatch(deactivateLoading());
    return response;
  },
);

export const getDocumentBase64Data = createAsyncThunk(
  'MyLoads/getDocumentData',
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchDocumentBase64Data(payLoad);
    dispatch(deactivateLoading());
    return response;
  },
);